/**
 * Adesão ao Programa de recomendação: POST /app/ambassador { slug } → { success, slug } ou
 * { error: slug_already_exists | slug_invalid }. Ao concluir, invalida ['me'] (a sessão passa a
 * ter o embaixador). O painel, o extrato e o resgate ficam em useReferral.ts; o gerador de
 * códigos (/app/code_generator) saiu do painel em 15/10/2026: os dias vão direto para a licença.
 */
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { api } from '../lib/apiClient';

interface AmbassadorResponse {
  error?: string;
  success?: boolean;
  slug?: string;
  already?: boolean;
}

/** Adesão ao programa. Resolve o `error` do backend (slug_already_exists) sem virar throw. */
export function useJoinAmbassador() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async (slug: string): Promise<AmbassadorResponse> => {
      const result = await api.post<AmbassadorResponse>('app/ambassador/', { slug }, {
        allowEmpty: true,
        rawErrors: true,
      });
      if (!result.ok) throw new Error(result.code);
      return result.data ?? {};
    },
    onSuccess: (data) => {
      if (!data.error) void qc.invalidateQueries({ queryKey: ['me'] });
    },
  });
}
